const Config = {
    Backend_URL: "",
	JWT_Token:"",
    Api_URL: "/web/cardissuer/accntlinking/pullprovision",
    env: 'DEV',
    Error_Dismiss_Seconds: 8,
    merchantName: localStorage.getItem('merchantName'),
    ipAddress:  "127.0.0.1",
    userTypeCode: "C",
    cancelRedirect:"",
    SetAsPrefferd:"",
    ForgotUserName:"https://card.discover.com/cardmembersvcs/registration/reg/goto?forwardName=forgotuserid",
    ForgotPassword:"https://card.discover.com/cardmembersvcs/registration/reg/goto?forwardName=pwdresethome",
    Privacy:"https://www.discover.com/privacy-statement/?ICMPGN=PUB_FTR_QL_PRIVACY",
    TermsOFUse:"https://www.discover.com/credit-cards/help-center/discover-terms-of-use.html?ICMPGN=PUB_FTR_QL_TERMS",
    cardImageUrl:"https://card.discover.com/global/images/discover/account/customerservice/cards/"
};
export default Config;